import { render, staticRenderFns } from "./AccountSettingLegal.vue?vue&type=template&id=66e3fe08"
import script from "./AccountSettingLegal.vue?vue&type=script&lang=js"
export * from "./AccountSettingLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports